import React from "react";
import sdk from "src/sdk";

import { translate } from "react-i18next";

import { DynamicForm } from "src/components/Form";
import { Box, Link } from "src/components";

const fields = ({ t }) => [
  {
    type: "section",
    title: t("olb.login.forgotPasswordTitle", {
      defaultValue: "Forgot Password",
    }),
    fields: [
      {
        key: "username",
        label: "Username",
        required: true,
        inputProps: {
          autoComplete: "off",
        },
        helpText: t("olb.login.forgotPasswordUsernameHelp", {
          defaultValue:
            "Once a valid username is submitted we will send a password reset link to all registered devices.",
        })
      },
    ],
  },
];

const ForgotLoginEntryForm = ({ history, t, ...props }) => (
  <Box my={2}>
    <DynamicForm
      formKey="forgotLogin"
      fields={fields}
      needsCaptcha={false}
      onSubmit={async data => {
        await sdk.requestPasswordResetLink(data);
        history.push("/app/login", {
          formSuccessMessage: t("olb.passwordReset.linkSent"),
        }); // route back to login page
      }}
      {...props}
    />
    <Link
      to="/app/login/forgotUsername"
      color="green"
      mt={2}
      align="center"
      fontSize={2}
    >
      {t("login.forgotUsername")}
    </Link>
  </Box>
);

export default translate("translations")(ForgotLoginEntryForm);



// WEBPACK FOOTER //
// ./src/banking/authentication/ForgotFlow/ForgotLogin/ForgotLoginEntryForm.js